import { render } from "./GalleriesPage.vue?vue&type=template&id=5be802cf&scoped=true"
import script from "./GalleriesPage.vue?vue&type=script&lang=js"
export * from "./GalleriesPage.vue?vue&type=script&lang=js"

import "./GalleriesPage.vue?vue&type=style&index=0&id=5be802cf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be802cf"]])

export default __exports__